import { PageTitle } from 'components/common/PageTitle/PageTitle';
import { DevicesList } from '../../components/devices/DevicesList';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { doList } from 'store/slices/devicesSlice';
import { SliceStatus } from 'constants/enums/slices';
import { useEffect } from 'react';
import { useCheckMonitor } from './hooks/useCheckMonitor';
import { CheckMonitor } from './components/CheckMonitor/CheckMonitor';

export const DevicesPage = () => {
  const dispatch = useAppDispatch();
  const { status: deviceSliceStatus, statusRevision } = useAppSelector(
    (state) => state.device
  );
  const monitor = useCheckMonitor();
  const { refresh } = monitor;

  useEffect(() => {
    if (deviceSliceStatus === SliceStatus.Empty) dispatch(doList());
  }, [deviceSliceStatus, dispatch]);
  useEffect(() => {
    refresh();
  }, [statusRevision, refresh]);

  return (
    <>
      <PageTitle>{`Dispositivos`}</PageTitle>
      <h1 className="title mb-5">Dispositivos</h1>
      <CheckMonitor monitor={monitor} />
      <DevicesList />
    </>
  );
};
